
































import {
  Vue,
  Component,
  Prop,
  Emit,
  Ref,
  Watch,
  Inject
} from "vue-property-decorator";
import {
  DeviceController,
  VideoInputDevice,
  ConsoleLogger
} from "amazon-chime-sdk-js";

import { getVideoInputDevice } from "@/utils/device";

@Component({})
export default class VideoPreview extends Vue {
  @Prop({ required: true }) deviceController!: DeviceController;
  @Prop({ required: true }) device!: MediaDeviceInfo;
  @Prop({ required: false }) isBlurVideo!: boolean;
  @Prop({ required: true }) isVideoOn!: boolean;
  @Ref() video!: HTMLVideoElement;
  @Inject() readonly chimeLogger!: ConsoleLogger;
  localIsVideoOn = false;

  get hasDevice() {
    return Boolean(this.device);
  }

  @Watch("device")
  onHasDeviceChange() {
    this.triggerPreview();
  }

  @Watch("isBlurVideo")
  onIsBlurVideoChange() {
    this.triggerPreview();
  }

  @Watch("isVideoOn")
  onIsVideoOnChange() {
    this.triggerPreview();
  }

  mounted() {
    this.localIsVideoOn = this.isVideoOn;
    this.triggerPreview();
  }

  async triggerPreview() {
    if (this.hasDevice) {
      if (this.isVideoOn) {
        // Device controller might not have device
        const videoInputDevice: VideoInputDevice | null = await getVideoInputDevice(
          this.device,
          this.isBlurVideo,
          this.chimeLogger
        );
        await this.deviceController.chooseVideoInputDevice(videoInputDevice);
        this.deviceController.startVideoPreviewForVideoInput(this.video);
      } else {
        this.deviceController.stopVideoPreviewForVideoInput(this.video);
      }
    }
  }

  @Emit()
  videoOn(v: boolean) {
    return v ? true : false;
  }

  @Emit()
  blurVideoOn(v: boolean) {
    return v ? true : false;
  }
}
